import { getAllTmsDataSetupConnections, downloadDumpConnectionsMaster } from '../../api/TMSDashboard/Setup';
const viewControl = {
  pageTitle: 'Setup',
  buckets: ['tms_setup_connections'],
  globalActions: [],
  fetchData: getAllTmsDataSetupConnections,
  downloadData: downloadDumpConnectionsMaster,
  downloadWithGlobalAppliedFilters: true,
  filters: ['hub', 'route', 'is_active'],
  isActiveOptionList: [
    { id: 'true', label: 'Active' },
    { id: 'false', label: 'Inactive' },
  ],
  actions: [
    {
      key: 'update',
      name: 'Update',
      isAllowed: (masterData) =>
        masterData.ops_dashboard_config?.parts_to_show?.setup_permission_obj
          ?.transport?.connection?.update,
    },
    {
      key: 'add',
      name: 'Add New',
      isAllowed: (masterData) =>
        masterData.ops_dashboard_config?.parts_to_show?.setup_permission_obj
          ?.transport?.connection?.update,
    },
    {
      key: 'download',
      name: 'Download',
    },
    {
      key: 'pagination',
      name: 'Pagination',
    },
    {
      key: 'perPageCountChange',
      name: 'Pagination Count',
    },
    {
      key: 'reload',
      name: 'Reload',
    },
  ],
};
const buckets = {
  tms_setup_connections: {
    name: 'Connection',
    filters: [],
    actions: [],
  },
};

const bucketColor = {};

export default { viewControl, buckets, bucketColor };
